import { render } from "./Section3.vue?vue&type=template&id=2a8c5b06"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"
script.render = render

export default script